module.exports = __webpack_public_path__ + "img/box3_item_bg2.ec494e31.png";